import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {IMAGE_BASE__URL} from '../../core/services/CusHttp';

@Component({
  selector: 'app-job-long',
  templateUrl: './job-long.component.html',
  styleUrls: ['./job-long.component.scss']
})
export class JobLongComponent implements OnInit {
  @Input() jobListes;//岗位列表
  @Output() jobSelectId: any = new EventEmitter();
  @Output() companySelectId: any = new EventEmitter();
  public ImgUrl: string = IMAGE_BASE__URL;
  constructor() { }

  ngOnInit() {
    // console.log("hehe",this.jobListes);
  }
  getJobId(did: number) {
    this.jobSelectId.emit(did);
  }
  getCompanyId(did: number) {
    this.companySelectId.emit(did);
  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/job/job-long/job-long.component.ts